export const menuItems = [
  {
    id: 25,
    label: "Dashboard",
    link: "/",
    parentId: 1,
  },

  {
    id: 1,
    label: "Master Asesmen",
    subItems: [
      {
        id: 2,
        label: "Jabatan Asesmen (KKJ)",
        link: "/master-asesmen/jabatan-kompetensi",
        parentId: 1,
      },
      {
        id: 3,
        label: "Kategori Studi Kasus",
        link: "/master-asesmen/kategori-studi-kasus",
        parentId: 1,
      },
      {
        id: 4,
        label: "Tools Asesmen",
        link: "/master-asesmen/tools-asesmen",
        parentId: 1,
      },
      {
        id: 30,
        label: "Penyusun Soal",
        link: "/master-asesmen/penyusun-soal",
        parentId: 1,
      },
      {
        id: 5,
        label: "Konfigurasi Timer",
        link: "/master/timer",
        parentId: 1,
      },
      {
        id: 6,
        label: "Treshold Nilai",
        link: "/master/treshold-nilai",
        parentId: 1,
      },
      {
        id: 23,
        label: "Treshold Analisa Soal",
        link: "/master/treshold-analisa-soal",
        parentId: 1,
      },
      {
        id: 18,
        label: "Pelaksanaan",
        link: "/master/pelaksanaan",
        parentId: 1,
      },
      {
        id: 22,
        label: "Kategori Klasifikasi",
        link: "/master/kategori-klasifikasi",
        parentId: 1,
      },
    ],
  },
  {
    id: 40,
    label: "Master Survei",
    subItems: [
      {
        id: 41,
        label: "Master Pertanyaan Survei",
        link: "/master/pertanyaan",
        parentId: 40,
      },
      {
        id: 42,
        label: "Master Jawaban Survei",
        link: "/master/jawaban",
        parentId: 40,
      },
      {
        id: 44,
        label: "Master Kategori Survei",
        link: "/master/kategori-survei",
        parentId: 40,
      },
      {
        id: 45,
        label: "Master Dimensi Survei",
        link: "/master/dimensi-survei",
        parentId: 40,
      },
    ],
  },
  {
    id: 24,
    label: "Master Kompetensi",
    link: "/master/kompetensi",
    parentId: 1,
  },
  {
    id: 10,
    label: "Jadwal Pelaksanaan",
    link: "/master-penjadwalan/jadwal-pelaksanaan",
    parentId: 1,
  },
  {
    id: 15,
    label: "Report Asesmen",
    subItems: [
      {
        id: 16,
        label: "Report Jadwal",
        link: "/report-jadwal",
        parentId: 1,
      },
      {
        id: 11,
        label: "Report Nilai Kompetensi",
        link: "/report-nilai-kompetensi",
        parentId: 1,
      },
      {
        id: 11,
        label: "Report Nilai Jabatan",
        link: "/report-nilai-jabatan",
        parentId: 1,
      },
      {
        id: 12,
        label: "Report Hasil",
        link: "/report-hasil",
        parentId: 1,
      },
      {
        id: 32,
        label: "Report Pembinaan Grade",
        link: "/report-pembinaan-grade",
        parentId: 15,
      },
      {
        id: 29,
        label: "Report Analisa Soal",
        link: "/report-analisa-soal",
        parentId: 1,
      },
      {
        id: 26,
        label: "Report Success Profile",
        link: "/report-success-profile",
        parentId: 1,
      },
      {
        id: 28,
        label: "Report Tools Asesmen",
        link: "/report-tools-asesmen",
        parentId: 1,
      },
      {
        id: 43,
        label: "Report Survei Peserta",
        link: "/report-survei-peserta",
        parentId: 1,
      },
    ],
  },
  {
    id: 13,
    label: "Log Peserta",
    link: "/log-peserta",
    parentId: 1,
  },
  {
    id: 14,
    label: "File Manager",
    link: "/file-manager",
    parentId: 1,
  },
  // {
  //   id: 31,
  //   label: "Informasi Ujian Demo",
  //   link: "/info-ujian-demo",
  //   parentId: 1,
  // },
  {
    id: 14,
    label: "Informasi Ujian",
    link: "/info-ujian",
    parentId: 1,
  },
  {
    id: 19,
    label: "Manajemen Hak Akses",
    subItems: [
      {
        id: 20,
        label: "Role User",
        link: "/master/role",
        parentId: 19,
      },
      {
        id: 21,
        label: "User",
        link: "/master/user",
        parentId: 19,
      },
    ],
  },
  {
    id: 33,
    label: "Audit Log",
    subItems: [
      {
        id: 34,
        label: "Log Aktivitas",
        link: "/log-activity",
        parentId: 33,
      },
      {
        id: 35,
        label: "Log Aksi",
        link: "/log-action",
        parentId: 33,
      },
      {
        id: 36,
        label: "Log Aktivitas Peserta",
        link: "/log-activity-peserta",
        parentId: 33,
      },
    ],
  },
];
